import React from "react";
import { createRoot } from "react-dom/client";
import moment from "moment";

import { SentryService } from "./services/sentryService";
import { LANG_RU } from "./constants/common";
import App from "./pages/App";

import "./style.scss";

moment.locale(LANG_RU);

SentryService();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <App />
);
